import React, { useState, useEffect } from 'react';
import { Form, Table, Button, Spinner, Row, Col, Tab, Nav } from "react-bootstrap";
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import Swal from 'sweetalert2';
import { useProvider, Toast } from '../context/MenuProvider';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

const Captacao =()=>{
  const navigate = useNavigate();
  const { tipo, id } = useParams(); 
  const [formType, setFormType] = useState(tipo || 'novo');
  const [query, setQuery] = useState('');
  
  useEffect(()=>{
    setFormType(tipo);
  }, [tipo]);
  
  useEffect(()=>{
    if(tipo !== formType){
      navigate(`/rede/${formType}`,{replace:true})
    }
  },[formType])
  
  return (
    <>
      <Form.Group controlId="formBasicSearch">
        <div className="input-group mb-3">
          <Form.Control 
            type="text" 
            placeholder="Digite a pesquisa" 
            value={query} 
            onChange={(e) => setQuery(e.target.value)} 
          />
          <Button variant="secondary">
              <i className="bi bi-search"></i>
          </Button>
        </div>
      </Form.Group>
      <Tab.Container id="details-tabs" activeKey={formType} onSelect={(k) => setFormType(k)}>
          <Nav variant="tabs" className="justify-content-center">
            <Nav.Item>
              <Nav.Link eventKey="novo">
                <i className="bx bx-user-plus fs-4"></i> 
                <span className="d-none d-md-inline ps-2">Novo</span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="qualificado">
                <i className="bx bx-user-check fs-4"></i> 
                <span className="d-none d-md-inline ps-2">Qualificado</span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="oportunidade">
                <i className="bx bx-user-voice fs-4"></i> 
                <span className="d-none d-md-inline ps-2">Apresenta</span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="parceiro">
                <i className="bx bx-group fs-4"></i> 
                <span className="d-none d-md-inline ps-2">Equipe</span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="descartado">
                <i className="bx bx-user-x fs-4"></i> 
                <span className="d-none d-md-inline ps-2">Descartado</span>
              </Nav.Link>
            </Nav.Item>
          </Nav>
  
          <Tab.Content className="">
            {formType === 'novo' && <Leads setFormType={setFormType} query={query}  status="novo"  />}
            {formType === 'qualificado' && <Leads setFormType={setFormType} query={query}  status="qualificado"  />}
            {formType === 'oportunidade' && <Leads setFormType={setFormType} query={query}  status="oportunidade"  />}
            {formType === 'parceiro' && <Leads setFormType={setFormType} query={query}  status="parceiro"  />}
            {formType === 'descartado' && <Leads setFormType={setFormType} query={query}  status="descartado"  />}
          </Tab.Content>
      </Tab.Container>
    </>
  )
}

const Leads = ({query, status, setFormType}) =>{
    const {
      crudAdmin,
      salvarDados,
      buscarDados,
      buscarDadosPorId,
    } = useProvider();
    const { get, post, patch, loading } = crudAdmin || {};
    const [leads, setLeads] = useState([]);
    const [filtros, setFiltros] = useState('todos');
    const [nextUrl, setNextUrl] = useState(null);
    const [tableSelected, setTableSelected] = useState(null);
    
    useEffect(()=>{
      buscarLeadsLocal(true);
    },[query, filtros])
    
    // Detecta o fim da página para carregar mais pagamentos
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarLeadsLocal();
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [nextUrl, loading]);
    
    const buscarLeadsLocal = async (novaBusca = false) => {
      try{
        const response = await buscarDados(
          "db_leads",
          (Item) => {
            return true
          },
          15,
          "data_atualizacao",
          "asc"
        );
        
        // if (response && response.length){
          
        // }
      }catch(err){
        
      }finally{
        buscarLeads(novaBusca);
      }
    }
    const buscarLeads = async (novaBusca = false) => {
        let url = `/conecta/leads/?expand=contato,regiao,lead_oportunidades&filtros=id,nome_do_cliente,nome,data_atualizacao,data_criacao,telefone,interesse,is_apresentado,is_cadastro,is_cadastro_ativo,status,is_cadastro_iniciado,observacoes,data_apresentacao,aceitou`;
        if (query) url += `&search=${query}`;
        if (!query) url += `&ordering=${status==="novo"?"-data_criacao":"-data_atualizacao"}`;
        url += `&status=${status==="oportunidade"?"qualificado":status}`;
        if (status==="parceiro") url += `&is_cadastro_iniciado=true`;
        if (status==="qualificado") url += `&is_apresentado=false`;
        if (status==="oportunidade") url += `&is_apresentado=true`;
        
        if (filtros==="interessar") url += `&interesse=false`;
        if (filtros==="interesse") url += `&interesse=true`;
          
        if (filtros==="aceitou") url += `&is_cadastro=true`;
        if (filtros==="recusou") url += `&is_cadastro=false`;
          
        if (filtros==="is_cadastro_ativo") url += `&is_cadastro_ativo=true`;
        if (filtros==="is_cadastro_inativo") url += `&is_cadastro=true&is_cadastro_ativo=false`;


        if (novaBusca) {
            //setLeads([]);
            setNextUrl(null);
        } else if (nextUrl) {
            url = nextUrl;
        } else {
            url = null;
        }

        if (!url) return;
        try{
          const response = await get(url, 'pagina');
          if (response && response.length){
            const novosItens = response[0].results;
            setLeads((itensAnteriores) => novaBusca ? novosItens : [...itensAnteriores, ...novosItens]);
            setNextUrl(response[0].next);
            await salvarDados("db_leads", novosItens);
          }else{
            setLeads([]);
          }
          
        }catch(err){
          // Toast.fire({
          //   icon: "error",
          //   title: "Falha ao buscar pagamentos"
          // });
        }finally{
          
        }
    };
    
    const removeItem = (item) =>{
        setLeads(leads.filter(lead => lead !== item));
    }
    const updateItem = (updatedItem) => {
        setLeads(leads.map(lead => lead.id === updatedItem.id ? updatedItem : lead));
    };
    const updateStatus = async(item, data) =>{
      try{
        const response = await patch(data, `/conecta/leads/${item.id}/?expand=contato,regiao,lead_oportunidades`);
        if(response && response.length){
          await salvarDados("db_leads", data);
          return response[0];
        }
      }catch(err){
        
      }
    }
    
    const addApresentacao = async(item) =>{
      try{
        return await post(item, `/conecta/oportunidades/?expand=lead,contato`);
      }catch(err){
        
      }
    }
    const updateApresentacao = async(id, item) =>{
      try{
        return await patch(item, `/conecta/oportunidades/${id}/?expand=lead,contato`);
      }catch(err){
        
      }
    }
    
    const editarObs = (x) =>{
        Swal.fire({
          title: "Lead",
          icon: "info",
          text: `"${x.contato.nome_do_cliente}"`,
          input: "textarea",
          inputValue:x.observacoes||'',
          inputAttributes: {
            rows: 5, // Define a altura do textarea
            maxlength: 500 // Limite de caracteres (opcional)
          },
          preDeny: () => {
            return Swal.getInput().value; // Retorna o valor do input antes de fechar
          },
          //showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Salvar",
          cancelButtonText: "Cancelar",
          //denyButtonText: `Recusou`,
          confirmButtonColor: "#3085d6",
          //cancelButtonColor: "#d33",
        }).then(async(result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            updateItem(await updateStatus(x, {"observacoes":result.value}));
          } 
        });
    }
    
    const opcoesQualificado = async (x) =>{
      if (!x.interesse){
          const item = await updateStatus(x, {"interesse":true});
          updateItem(item);
      }else if(!x.is_apresentado){
        Swal.fire({
          title: "Apresentação",
          icon: "info",
          text: `"${x.contato.nome_do_cliente}" qual foi o resultado da apresentação da oportunidade?`,
          input: "textarea",
          inputValue:x.observacoes||'',
          inputAttributes: {
            rows: 5, // Define a altura do textarea
            maxlength: 500 // Limite de caracteres (opcional)
          },
          preDeny: () => {
            return Swal.getInput().value; // Retorna o valor do input antes de fechar
          },
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Aceitou",
          cancelButtonText: "Cancelar",
          denyButtonText: `Recusou`,
          confirmButtonColor: "#3085d6",
          //cancelButtonColor: "#d33",
        }).then(async(result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            const item = await addApresentacao({
              "lead": x.id,
              "observacoes":result.value,
              "aceitou":true
            });
            updateItem(await updateStatus(x, {"observacoes":result.value}));
            removeItem(x);
            setFormType("oportunidade");
          } else if (result.isDenied) {
            const item = await addApresentacao({
              "lead": x.id,
              "observacoes":result.value,
              "aceitou":false
            });
            updateItem(await updateStatus(x, {"observacoes":result.value}));
            removeItem(x);
            setFormType("oportunidade");
          }
        });
      }else if(!x.is_cadastro){
        let observacoesTemp = x.observacoes || ""; // Variável temporária para armazenar o valor
        
        Swal.fire({
          title: "Acompanhamento",
          icon: "info",
          text: `"${x.contato.nome_do_cliente}" já quer fazer parte da equipe?`,
          input: "textarea",
          inputValue: observacoesTemp,
          inputAttributes: {
            rows: 5,
            maxlength: 500
          },
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Aceitou",
          cancelButtonText: "Ainda não",
          denyButtonText: `Descartar`,
          confirmButtonColor: "#3085d6",
          didOpen: () => {
            const input = Swal.getInput();
            input.addEventListener("input", () => {
              observacoesTemp = input.value; // Atualiza a variável conforme o usuário digita
            });
          },
          willClose: () => {
            observacoesTemp = Swal.getInput().value || ""; // Garante que o valor seja salvo antes de fechar
          }
        }).then(async (result) => {
          if (result.isConfirmed) {
            await addApresentacao({
              "lead": x.id,
              "observacoes": observacoesTemp,
              "aceitou": true
            });
            updateItem(await updateStatus(x, { "observacoes": observacoesTemp }));
          } else if (result.isDenied) {
            await updateStatus(x, { "status": "descartado", "observacoes": observacoesTemp });
            removeItem(x);
          } else {
            updateItem(await updateStatus(x, { "observacoes": observacoesTemp }));
          }
        });
      }else if(!x.is_cadastro_ativo){
        const response = await get(`/conecta/parceiros/?lead_ids=${x.id}&ordering=-data_entrada&limit=1`);
        Swal.fire({
          title: "Acompanhamento de Cadastro",
          icon: "info",
          text: `"${x.contato.nome_do_cliente}"`,
          input: "textarea",
          inputValue:x.observacoes||``,
          inputAttributes: {
            rows: 5, // Define a altura do textarea
            maxlength: 500 // Limite de caracteres (opcional)
          },
          preDeny: () => {
            return Swal.getInput().value; // Retorna o valor do input antes de fechar
          },
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Ativar",
          cancelButtonText: "Cancelar",
          denyButtonText: `Descartar`,
          confirmButtonColor: "#3085d6",
          //cancelButtonColor: "#d33",
        }).then(async(result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            if (response && response.length){
              const item = await patch({
                'ativo':true, 
                'observacoes':result.value
              },`/conecta/parceiros/${response[0].results[0]?.id}/`);
              updateItem(await updateStatus(x, {"observacoes":result.value}));
            }
          } else if (result.isDenied) {
            await updateStatus(x, {"status":"descartado", "observacoes":result.value});
            removeItem(x);
          }
        });
      }else if(x.is_cadastro_ativo && !x.is_cadastro_iniciado){
        const response = await get(`/conecta/parceiros/?lead_ids=${x.id}&ativo=true&ordering=-data_entrada&limit=1`);
        Swal.fire({
          title: "Concluiu o processo?",
          icon: "question",
          text: `"${x.contato.nome_do_cliente}"`,
          input: "textarea",
          inputValue:x.observacoes||``,
          inputAttributes: {
            rows: 5, // Define a altura do textarea
            maxlength: 500 // Limite de caracteres (opcional)
          },
          preDeny: () => {
            return Swal.getInput().value; // Retorna o valor do input antes de fechar
          },
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Concluir",
          cancelButtonText: "Cancelar",
          denyButtonText: `Desativar`,
          confirmButtonColor: "#3085d6",
          //cancelButtonColor: "#d33",
        }).then(async(result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            if (response && response.length){
              const item = await patch({
                'iniciado':true,
                'observacoes':result.value
              },`/conecta/parceiros/${response[0].results[0]?.id}/`);
              updateItem(await updateStatus(x, {"observacoes":result.value}));
              removeItem(x);
              setFormType("parceiro");
            }
          } else if (result.isDenied) {
            if (response && response.length){
              const item = await patch({
                'iniciado':false, 
                'ativo':false,
                'observacoes':result.value 
                },`/conecta/parceiros/${response[0].results[0].id}/`);
              updateItem(await updateStatus(x, {"observacoes":result.value}));
            }
          }
        });
      }else if(x.is_cadastro_iniciado){
        const response = await get(`/conecta/parceiros/?lead_ids=${x.id}&ativo=true&ordering=-data_entrada&limit=1&expand=oportunidade`);
        Swal.fire({
          title: "Desativar da equipe?",
          icon: "question",
          text: `"${x.contato.nome_do_cliente}" ${response && response.length?response[0].results[0]?.oportunidade?.observacoes||'':''}`,
          input: "textarea",
          inputValue:response && response.length?response[0].results[0]?.observacoes||'':'',
          inputAttributes: {
            rows: 5, // Define a altura do textarea
            maxlength: 500 // Limite de caracteres (opcional)
          },
          preDeny: () => {
            return Swal.getInput().value; // Retorna o valor do input antes de fechar
          },
          //showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Sim, desativar",
          cancelButtonText: "Cancelar",
          //denyButtonText: `Desativar`,
          confirmButtonColor: "#d33",
          //cancelButtonColor: "#d33",
        }).then(async(result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            if (response && response.length){
              const item = await patch({
                'iniciado':false,
                'observacoes':result.value
              },`/conecta/parceiros/${response[0].results[0].id}/?expand=lead,oportunidade,contato`);
              updateItem(item[0].oportunidade.lead);
              removeItem(x);
              setFormType("oportunidade");
            }
          }
        });
      }
    }
    
    const mudarStatus = async(x) =>{
      if(status === "descartado"){
        Swal.fire({
          title: "Requalificar?",
          icon: "question",
          text: `Requalificar "${x.contato.nome_do_cliente}" no passo de requalificação de prospecção`,
          showCancelButton: true,
          confirmButtonText: "Qualificar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          //cancelButtonColor: "#d33",
        }).then(async(result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            await updateStatus(x, {"status":"qualificado"});
            removeItem(x);
            setFormType(x.is_apresentado?"oportunidade":"qualificado");
          }
        });
      }else if(status === "qualificado"){
        opcoesQualificado(x);
      }else if(status === "novo"){
        await updateStatus(x, {"status":"qualificado"});
        removeItem(x);
        setFormType("qualificado");
      }
    }
    
    const descartarLead = (x) =>{
        Swal.fire({
          title: "Descartar",
          icon: "question",
          text: `Tem certeza que deseja descartar "${x.contato.nome_do_cliente}" no passo de qualificação de prospecção?`,
          //showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Sim Confirmar",
          cancelButtonText: "Cancelar",
          //denyButtonText: `Descartar`,
          //confirmButtonColor: "#3085d6",
          confirmButtonColor: "#d33",
          //cancelButtonColor: "#d33",
        }).then(async(result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            await updateStatus(x, {"status":"descartado"});
            removeItem(x);
          }
        });
    }
 
    const formatTelefone = (telefone) => {
      if (!telefone) return '';
      telefone = telefone.replace(/\D/g, '');
      if (!telefone) return '';
      return `+55${telefone}`;
    }
    
    const sendWhatsApp = (x)=>{
      const texto =`Olá ${x.nome_do_cliente.trimStart().split(' ')[0]}`
      const mensagem = encodeURIComponent(texto);
      const url = `whatsapp://send?${formatTelefone(x.telefone) ? `phone=${formatTelefone(x.telefone)}&` : ""}text=${mensagem}`;
      window.open(url);
    }
    
    return (
      <div className="mb-5 pb-5">
        {status === "novo" && <BotaoFlutuante to="/clientes/novo" icon="bi-plus" />}
        {status === "novo" && <Col className="text-center py-3 fs-4">Lista de novos Contatos</Col>}
        {status === "parceiro" && <Col className="text-center py-3 fs-4">Lista de Parceiros de equipe</Col>}
        {(status === "qualificado" || status === "oportunidade") && (<>
          <Col xs={12} className="text-center pt-3 fs-4">Lista de {status==="qualificado"?"Contatos qualificados":"Acompanhamento"}</Col>
          <Col xs={12} className="pb-3">
            <Form.Group controlId="formSelectStockFilter" className="mt-3">
                <Form.Label>Status de Acompanhamento</Form.Label>
                <Form.Control
                  as="select"
                  value={filtros}
                  onChange={(e) => setFiltros(e.target.value)}
                >
                  <option value="todos">Todos</option>
                  {status === "qualificado" && (
                    <>
                      <option value="interessar">À interessar</option>
                      <option value="interesse">Mostrou interessado</option>
                    </>
                  )}
                  {status === "oportunidade" && (
                    <>
                      <option value="aceitou">Aceitou e fez pré cadastro</option>
                      <option value="recusou">Recusou a Oportunidade</option>
                      <option value="is_cadastro_ativo">Pré cadastro ativo</option>
                      <option value="is_cadastro_inativo">Pré cadastro inativo</option>
                    </>
                  )}
                </Form.Control>
            </Form.Group>
          </Col>
        </>)}
        {status === "descartado" && <Col className="text-center py-3 fs-4">Lista de Contatos descartados</Col>}
        
        <div className="list-group mt-3">
          {leads.map((x, index) => (
            <RenderizarProduto
              key={x.id} 
              col="d-none"
              lm="mb-1"
              text1={dayjs(x.interesse?x.data_atualizacao:x.data_criacao).format("DD/MM/YYYY dddd")}
              titulo={`${x.contato.nome_do_cliente}`}
              text2={(<>
                {x.contato?.regiao?.nome && (<div>{x.contato?.regiao?.nome}</div>)}
                <Row>
                  <Col className={x.status==='descartado'||(x.is_apresentado && !x.is_cadastro)?`text-secondary text-opacity-75`:``}>
                    <i className={`bx bx${x.interesse?'s':''}-star`}></i>
                    <i className={`bx bx${x.interesse && x.is_apresentado?'s':''}-star`}></i>
                    <i className={`bx bx${x.interesse && x.is_apresentado && x.is_cadastro?'s':''}-star`}></i>
                    <i className={`bx bx${x.interesse && x.is_apresentado && x.is_cadastro && x.is_cadastro_ativo?'s':''}-star`}></i>
                    <i className={`bx bx${x.interesse && x.is_apresentado && x.is_cadastro && x.is_cadastro_ativo && x.is_cadastro_iniciado?'s':''}-star`}></i>
                  </Col>
                  <Col xs="auto">
                    {(x.status==="novo" || x.status==="descartado") && (<Button onClick={()=>mudarStatus(x)} variant="outline-success" className="btn-sm ms-1"><i className="bx bx-check-double"></i> Qualificar</Button>)}
                    {(x.status==="qualificado" || x.status==="parceiro") && (<>
                      {!x.interesse && (
                        <Button onClick={()=>opcoesQualificado(x)} variant="outline-success" className="btn-sm ms-1"><i className="bx bx-check"></i>Iniciar</Button>
                      )}
                      {x.interesse && !x.is_apresentado && (
                        <Button onClick={()=>opcoesQualificado(x)} variant="outline-success" className="btn-sm ms-1"><i className="bx bx-check"></i> Apresentar</Button>
                      )}
                      {x.interesse && x.is_apresentado && !x.is_cadastro && (
                        <Button onClick={()=>opcoesQualificado(x)} variant="outline-success" className="btn-sm ms-1"><i className="bx bx-check"></i> Aceitar</Button>
                      )}
                      {x.interesse && x.is_apresentado && x.is_cadastro && !x.is_cadastro_ativo && (
                        <Button onClick={()=>opcoesQualificado(x)} variant="outline-success" className="btn-sm ms-1"><i className="bx bx-check"></i> Ativar</Button>
                      )}
                      {x.interesse && x.is_apresentado && x.is_cadastro && x.is_cadastro_ativo && !x.is_cadastro_iniciado && (
                        <Button onClick={()=>opcoesQualificado(x)} variant="outline-success" className="btn-sm ms-1"><i className="bx bx-check"></i> Efetivar</Button>
                      )}
                      {x.interesse && x.is_apresentado && x.is_cadastro && x.is_cadastro_ativo && x.is_cadastro_iniciado && (
                        <Button onClick={()=>opcoesQualificado(x)} variant="outline-danger" className="btn-sm ms-1"><i className="bx bx-check"></i> Reverter</Button>
                      )}
                    </>)}
                    {x.contato?.telefone && (<Button onClick={()=>sendWhatsApp(x.contato)} variant="outline-success" className="btn-sm ms-1"><i className="bx bxl-whatsapp"></i></Button>)}
                    <Button onClick={()=>editarObs(x)} variant="outline-warning" className="btn-sm ms-1"><i className="bx bx-edit"></i></Button>
                    {x.status !== "descartado" && !x.is_cadastro_iniciado && (<Button onClick={()=>descartarLead(x)} variant="outline-danger" className="btn-sm ms-1"><i className="bx bx-trash"></i></Button>)}
                  </Col>
                  {x.observacoes && (<Col xs={12} className="mt-2">
                    {x.observacoes}
                  </Col>)}
                  {x.lead_oportunidades.length>0 && (
                    <Col xs={12} className="mt-2 py-1 border-top">
                      {x.lead_oportunidades.map((x, index) => (
                        <Row>
                          <Col>Apresentação {dayjs(x.data_apresentacao).format("DD/MM/YYYY")}</Col>
                          <Col xs="auto">{x.aceitou?"Aceitou":"Recusou"}</Col>
                        </Row>
                      ))}
                    </Col>
                  )}
                </Row>
              </>)}
            />
          ))}
          {!leads.length && (
            <>
              {!loading && <p className="text-center text-muted">Nenhum lead encontrada.</p>}
            </>
          )}
          {loading && <p className="text-center"><Spinner animation="border" /></p>}
        </div>
        {nextUrl && !loading && (
          <Col xs={12} md={4} className="mx-auto">
            <Button variant="secondary" onClick={() => buscarLeadsLocal(false)} className="mt-2 w-100">
              Buscar mais...
            </Button>
          </Col>
        )}
      </div>
    )
}

export default Captacao;